import { getData, postData } from "./httpHelpers";
import { redirectToCheckout } from "./stripeService";

export const getBalance = async () => await getData(`${process.env.REACT_APP_API_URL}/accounts/current/balance`);

export const addBalance = async (value) => {
    const sessionResponse = await postData(`${process.env.REACT_APP_API_URL}/recharge`, {amount: value * 100});
    await redirectToCheckout(sessionResponse.id);
};
